<div class="border border-round-2xl inline-flex justify-content-center align-items-center" >
<p class="text-center text-xs font-normal p-0 m-0">{{titles[0]}}<ng-container *ngIf="titles.length>1">... +{{titles.length-1}}</ng-container></p>
</div>
